import React from 'react'
import Icons from '../Images'


export function ModalInfo(tempText) {
    return <div className="uploadImgErrBox">
        <img
            src={Icons.error1}
            className="uploadImgErrImg"
        ></img>
        <div className="uploadImgErrText">{tempText}</div>
    </div>
}